<form class="form-inline my-2 my-md-0" (ngSubmit)="search()">
  <div class="input-group ms-sm-2">
    <input
      class="form-control"
      type="text"
      placeholder="Search"
      aria-label="Search"
      name="searchTerm"
      [(ngModel)]="searchTerm">

    <button class="btn btn-outline-secondary" type="submit">
      <fa-icon [icon]="faSearch" [class]="['text-danger']" />
    </button>
  </div>
</form>
